<template>
  <div class="main-container">
    <div class="container header column">
      <h1>{{ savedMessage }}</h1>
      <h2>{{ savedData }}</h2>
    </div>
    <div class="container">
      <router-link v-if="getParametrosGeneralesAmb.mostrarBtnIrRecepcionAR" :to="{ name: 'printNumber', params: { numRecId: numRecIdConTurnoFromLocalStorage } }" tag="button" class="btn-secondary">
        {{getMessage('BTN_IR_RECEPCION')}}
      </router-link>
      <router-link
        :to="{ name: 'patientSearch' }"
        tag="button"
        class="btn-secondary"
        >
        {{getMessage('BTN_CORREGIR_DOCUMENTO')}}
      </router-link>
    </div>
    <div class="container">
      <router-link :to="{ name: 'TotemHome' }" tag="button" class="btn-secondary">
        {{ getMessage('BTN_VOLVER') }}
      </router-link>
    </div>
    <app-back-home :compFrom="'patientAppointmentNotFound'"></app-back-home>
  </div>
</template>
<script>
import BackHome from '@/components/AutoRecepcion/BackHome'
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    'app-back-home': BackHome
  },
  props: {
    message: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: String,
      required: false,
      defualt: ''
    }
  },
  mounted: function () {
    var vm = this
    this.numRecIdConTurnoFromLocalStorage = +localStorage.getItem('numRecConTurno')
    if (vm.message !== '' && vm.data !== '') {
      vm.setMessageData({ message: vm.message, data: vm.data })
    }
  },
  computed: {
    ...mapState('GeneralAR', ['savedMessage', 'savedData']),
    ...mapGetters('GeneralAR', ['getMessage']),
    ...mapGetters('InitConfig', ['getParametrosGeneralesAmb'])
  },
  data () {
    return {
      numRecIdConTurnoFromLocalStorage: null
    }
  },
  methods: {
    ...mapMutations('GeneralAR', ['setMessageData'])
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>
